var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("plain-text-control", {
          attrs: { id: _vm.title, title: _vm.title, required: _vm.required }
        }),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "table radio-tablerow",
            attrs: { "aria-labelledby": _vm.title, role: "presentation" }
          },
          _vm._l(_vm.items, function(item, index) {
            return _vm.items.length > 0
              ? _c(
                  "tr",
                  [
                    _c(
                      "td",
                      { staticClass: "w-70", attrs: { id: item.name } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(item.name)) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: { required: _vm.required }, slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              var failedRules = ref.failedRules
                              return [
                                _c(
                                  "td",
                                  {
                                    staticClass: "w-30 input-cell align-middle",
                                    class: _vm.getValidationErrorClasses(
                                      failedRules
                                    )
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          role: "radiogroup",
                                          "aria-labelledby": item.name
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-check-inline" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form-check-label",
                                                attrs: {
                                                  for: item.name + "_yes"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.value,
                                                      expression: "item.value"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    id: item.name + "_yes",
                                                    name: item.name,
                                                    type: "radio",
                                                    value: "true",
                                                    disabled: _vm.isReadOnly,
                                                    "aria-disabled":
                                                      _vm.isReadOnly,
                                                    "aria-invalid":
                                                      _vm.required &&
                                                      !_vm.isReadOnly &&
                                                      errors.length > 0
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      item.value,
                                                      "true"
                                                    )
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.$emit(
                                                        "update:value",
                                                        $event.target.value
                                                      )
                                                    },
                                                    change: [
                                                      function($event) {
                                                        return _vm.$set(
                                                          item,
                                                          "value",
                                                          "true"
                                                        )
                                                      },
                                                      function($event) {
                                                        return _vm.forceSave()
                                                      }
                                                    ]
                                                  }
                                                }),
                                                _vm._v(
                                                  _vm._s(_vm.$t("Radio_Yes")) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-check-inline" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form-check-label",
                                                attrs: {
                                                  for: item.name + "_no"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.value,
                                                      expression: "item.value"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    id: item.name + "_no",
                                                    name: item.name,
                                                    type: "radio",
                                                    value: "false",
                                                    disabled: _vm.isReadOnly,
                                                    "aria-disabled":
                                                      _vm.isReadOnly,
                                                    "aria-invalid":
                                                      _vm.required &&
                                                      !_vm.isReadOnly &&
                                                      errors.length > 0
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      item.value,
                                                      "false"
                                                    )
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.$emit(
                                                        "update:value",
                                                        $event.target.value
                                                      )
                                                    },
                                                    change: [
                                                      function($event) {
                                                        return _vm.$set(
                                                          item,
                                                          "value",
                                                          "false"
                                                        )
                                                      },
                                                      function($event) {
                                                        return _vm.forceSave()
                                                      }
                                                    ]
                                                  }
                                                }),
                                                _vm._v(
                                                  _vm._s(_vm.$t("Radio_No")) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }